import { Col, Layout, Row, Spin } from 'antd';
import { Timestamp } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser, updateUser } from '../../apis/apis';
import Academy from '../../components/Academy/Academy';
import Assistents from '../../components/Assistents/Assistents';
import ChatPageContent from '../../components/ChatPageContent/ChatPageContent';
import LeftMenuSlider from '../../components/LeftMenuSlider/LeftMenuSlider';
import PromptsPageContent from '../../components/PromptsPageContent/PromptsPageContent';
import FAQContent from '../../components/faq/FAQContent';
import SupportInfo from '../../components/SupportInfo/SupportInfo';
import { User } from '../../models/models';
import { RootState } from '../../redux/store';
import AcceptTermsPage from '../AcceptTermPage/AcceptTermsPage';
import ChatPageStyles from './ChatPageStyles';
import PromptMasterPageContent from '../../components/PromptMasterPageContent/PromptMasterPageContent';


export const ChatPage = () => {

  // THEME
  const styles = ChatPageStyles();

  // USE STATES
  const [loading, setLoading] = useState(true);
  const [requiereAcceptTerms, setRequiereAcceptTerms] = useState(true);

  // REDUX
  const dispatch = useDispatch();
  const menuId = useSelector((state: RootState) => state.menuSelection.menuId);

  // USE EFFECTS
  useEffect(() => {
    handleGetUserData();
  }, []);

  // Reset scroll position when changing pages
  useEffect(() => {
    // Reset window scroll
    window.scrollTo(0, 0);

    // Reset document element scroll
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }

    // Reset body scroll
    if (document.body) {
      document.body.scrollTop = 0;
    }

    // Reset any scrollable containers - use a small delay to ensure DOM is ready
    setTimeout(() => {
      const scrollableContainers = document.querySelectorAll(
        '[style*="overflow"], [style*="overflowY"], .ant-layout, div[class*="scroll"]'
      );
      scrollableContainers.forEach((container) => {
        if (container instanceof HTMLElement && container.scrollTop > 0) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }
      });
    }, 0);
  }, [menuId]);

  // FUNCTIONS
  async function handleGetUserData() {
    const userData: User | null = await getUser();
    if (!userData) {
      console.error('Error getting user in handleGetUserData()');
      return;
    }
    if (userData.acceptedTerms) {
      setLoading(false);
      setRequiereAcceptTerms(false);
      //validate  lastLogin and update it if is more than 1 day
      const lastLoginTimestamp = userData.lastLogin as Timestamp | null;
      const now = new Date();

      if (lastLoginTimestamp) {
        const lastLogin = lastLoginTimestamp.toDate(); // Convierte el Timestamp a Date
        if (now.getTime() - lastLogin.getTime() > 86400000) { // 86400000 ms = 24 horas
          updateUser(userData);
        }
      }
    } else {
      setLoading(false);
      setRequiereAcceptTerms(true);
    }
  }

  function showBodyContent() {
    switch (menuId) {
      case 'chat':
        return <ChatPageContent />;
      case 'faq':
        return <FAQContent />;
      case 'prompts':
        return <PromptsPageContent />;
      case 'academy':
        return <Academy />;
      case 'assistants':
        return <Assistents />;
      case 'support':
        return <SupportInfo />;
      case 'prompt-master':
        return <PromptMasterPageContent />;
      default:
        return <></>;
    }
  }


  if (loading) {
    return (
      <Layout style={{ height: '100vh' }}>
        <Row justify={'center'} align={'middle'} style={{ height: '100%' }}>
          <Col>
            <Spin size="large" />
          </Col>
        </Row>
      </Layout>
    );
  }

  if (requiereAcceptTerms) {
    return (
      <AcceptTermsPage onAccept={handleGetUserData} />
    );
  }


  return (
    <Layout style={styles.layout}>
      <LeftMenuSlider />
      <Layout style={{ backgroundColor: 'transparent' }}>
        {showBodyContent()}
      </Layout>
    </Layout>
  );
}
